import { Component, OnInit, forwardRef, Input, ElementRef, Output, EventEmitter, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PlaceService } from '../../_services/place.service';

@Component({
  selector: 'app-city-autocomplete',
  templateUrl: './city-autocomplete.component.html',
  styleUrls: ['./city-autocomplete.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CityAutocompleteComponent),
      multi: true
    }
  ]
})
  
export class CityAutocompleteComponent implements ControlValueAccessor {
  @Input() placeholder: any = "N'importe quelle Ville";
  @Input() value;
  @Input() allowAdd: boolean = false;
  @Output() notFound: EventEmitter<string> = new EventEmitter<string>();
  @Output() valueSelected: EventEmitter<string> = new EventEmitter<string>();
  
  propagateChange = (_: any) => { };

  private cities: object[];
  private selected: object;
  private showResults: boolean = false;
  private noResults: boolean = false;


  constructor(private service: PlaceService, private elRef: ElementRef) {
  }

  writeValue(value: any): void {

    //console.log(this.elRef.nativeElement.querySelector('#citySearchInput'));

    if (value !== undefined && value !== "" && value !== null) {
      // If an Object is given, just take the ID as value
      if (value instanceof Object) {
        this.value = value.name;
        this.selected = value;
        this.elRef.nativeElement.querySelector('#citySearchInput').value = value.name;
      } else { // Is Not an Empty String
        this.service.getCity(value).subscribe(response => {
          if (response) {
            this.selected = response;
            this.elRef.nativeElement.querySelector('#citySearchInput').value = response.name;
            this.value = response.name;
          } else {
            this.selected = undefined;
            this.elRef.nativeElement.querySelector('#citySearchInput').value = null;
            this.value = "";
          }

        });
      }
    } else {
      this.value = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }

  changeValue(value) {
    this.propagateChange(value);
  }

  search(value) {
    this.service.autocompleteCities(value || '').subscribe(response => {
      this.cities = response;
      this.noResults = !this.cities.length;
    });
  }

  ngOnInit() {
  }

  selectResult(city) {
    this.elRef.nativeElement.querySelector('#citySearchInput').value = city.name;
    this.changeValue(city.id);
    this.valueSelected.emit(city);
  }

  onFocus() {
    this.search('');
    this.showResults = true;
  }

  onBlur() {
    setTimeout(function () {
      this.showResults = false;
    }.bind(this), 200);
  }

  triggerAdd(cityName) {
    this.notFound.emit(cityName);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/city-autocomplete/city-autocomplete.component.ts